import React from 'react';
import { Box, useWidth } from 'vindi-ds-components';
import styles from './styles';

function HeaderActions({ children }) {
  if (!children) return null;

  const breakpoint = useWidth();

  if (['md', 'lg', 'xl'].includes(breakpoint)) {
    return <Box css={styles.actions}>{children}</Box>;
  }

  const lastChildren = children[children?.length - 1] || children;

  return <Box css={styles.actions}>{lastChildren}</Box>;
}

export default HeaderActions;
